(function () {
  function patchDisclosure(tagName) {
    customElements.whenDefined(tagName).then(function () {
      var Ctor = customElements.get(tagName);
      if (!Ctor) return;

      Ctor.prototype.createShowAnimationControls = function () {
        this.contentElement.style.opacity = "1";
        return {
          finished: Promise.resolve(true),
          finish: function () {},
        };
      };

      Ctor.prototype.createHideAnimationControls = function () {
        this.contentElement.style.opacity = "0";
        return {
          finished: Promise.resolve(true),
          finish: function () {},
        };
      };
    });
  }

  patchDisclosure("dropdown-menu-disclosure");
  patchDisclosure("mega-menu-disclosure");
})();